import { render, staticRenderFns } from "./inviteSave.vue?vue&type=template&id=b0b17c98&scoped=true"
import script from "./inviteSave.vue?vue&type=script&lang=js"
export * from "./inviteSave.vue?vue&type=script&lang=js"
import style0 from "./inviteSave.vue?vue&type=style&index=0&id=b0b17c98&prod&lang=less&scoped=true"
import style1 from "./inviteSave.vue?vue&type=style&index=1&id=b0b17c98&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b17c98",
  null
  
)

export default component.exports